import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { ReactComponent as AddIcon } from 'assets/icons/addIcon.svg';
import { GoBackButtonWithTitle } from 'components';
import { CreateButton } from 'features/documentCategories/components/DocumentCategories/styled';
import { useSubscription } from 'hooks';
import { Links } from 'settings';
import { theme } from 'styles';

import { HeaderW } from './styled';

export function EmployeesTableHeader(): ReactElement {
  const { t } = useTranslation();
  const { isTrial } = useSubscription();

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const inviteEmployeeRoute = pathname.includes('resources')
    ? Links.resources.employees.invite
    : Links.we.employees.invite;

  return (
    <HeaderW>
      <GoBackButtonWithTitle title={t('employee.table.header.title')} />

      {!isTrial ? (
        <CreateButton
          startIcon={<AddIcon style={{ fill: theme.palette.common.white }} />}
          onClick={() => navigate(inviteEmployeeRoute)}
          style={{
            height: '56px',
            padding: '16px 16px',
            backgroundColor: theme.palette.info.main,
            color: theme.palette.common.white,
            fontSize: '14px',
            fontWeight: 400,
            borderRadius: '8px',
            textTransform: 'none',
            width: '150px',
          }}
        >
          {t('common.add')}
        </CreateButton>
      ) : null}
    </HeaderW>
  );
}
